import { Injectable, Inject, Injector, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {tap, map, catchError} from 'rxjs/operators';
import 'rxjs/add/operator/let';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DjangoBaseUser} from './django-base-user';
import {AuthorizationData} from '../generic';
import {GeneralMessages} from '../../services/';


@Injectable()
export class DjangoSessionAuthenticationService /*implements AuthorizationService*/ {
  private currentUser: any;
  private authorizationUrl = '/auth';
  private csrftoken = null;
  private userLogged$: BehaviorSubject<DjangoBaseUser|undefined>;
  private tapSetUser = tap((result: DjangoBaseUser) => {
    if (result['csrf']) {
      this.csrftoken = result['csrf'];
    }
    if (result['id'] === -1) {
      result = undefined;
    }
    this.currentUser = result;
    this.userLogged$.next(result);
  });

  constructor(private http: HttpClient, @Optional() private messagery: GeneralMessages) {
    this.userLogged$ = new BehaviorSubject<DjangoBaseUser|undefined>(undefined);
  }

  private _getUserLogged(): Observable<DjangoBaseUser> {
    return this.http.get(`${this.authorizationUrl}/logged/`).pipe(
      this.tapSetUser,
    )as Observable<DjangoBaseUser>;
  }

  private generateLoginErrorMessage(error) {
    this.messagery.error('Datos de acceso incorrectos', 'El correo y la contraseña no han sido reconocidos, \n si tiene una cuenta intentelo de nuevo. \n Si ha olvidado su contraseña, puede recuperarla automaticamente. \n Si no tiene cuenta, puede crear una de forma muy sencilla.');
  }

  private generateRegisterErrorMessage(error) {
    if(error.error.username && error.error.username[0] == 'A user with that username already exists.')
      this.messagery.error('Cuenta existente', 'Esta dirección de correo pertenece a una cuenta existente. Si has olvidado tu contraseña, puedes recuperarla.');
    else this.messagery.error('Faltan campos', 'Por favor, completa todos los campos del formulario para crear la cuenta.');  //JSON.stringify(error.error)
  }

  login(credentials: AuthorizationData): Observable<DjangoBaseUser> {
    const data = {
      username: credentials.username,
      password: credentials.password
    };
    return this.http.post(`${this.authorizationUrl}/login/`, data).pipe(
      this.tapSetUser,
      tap(result => {},
          error => {
            if (this.messagery) {
              this.generateLoginErrorMessage(error);
            }
          })
    ) as Observable<DjangoBaseUser>;
  }

  passwordReset(email: string) {
    const data = {email: email};
    return this.http.post(`${this.authorizationUrl}/password_reset/`, data);
  }

  deleteSelfUserData() {
    return this.http.post(`${this.authorizationUrl}/delete_me/`, {}).pipe(
      tap(data => this.logout())
    );
  }

  logout() {
    this.userLogged$.next(undefined);
    this.currentUser = undefined;
    return this.http.get(`${this.authorizationUrl}/logout/`);
  }

  getUserLogged(): Promise<DjangoBaseUser | undefined> {
    const promise = new Promise<DjangoBaseUser | undefined>((resolve, reject) => {
        const resolveValue = this.currentUser ? this.currentUser : this._getUserLogged().toPromise();
        resolve(resolveValue);
      }
    );
    return promise;
  }
  getUserLogged$(): Observable<DjangoBaseUser | undefined> {
    return this.userLogged$.asObservable();
  }
  register(data) {
    if (!data.username) {
      data.username = data.email;
    }
    return this.http.post(`${this.authorizationUrl}/register/`, data).pipe(
      tap(result => {},
        error => {
          console.log('register error');
          if (this.messagery) {
            this.generateRegisterErrorMessage(error);
          }
        })
    ) as Observable<DjangoBaseUser>;
  }
  getCsrfToken() {
    return this.csrftoken;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/authorization/custom/django-session-authentication.service.ts